import { FormattedMessage } from "react-intl";
import LoaderBar from "app/pages/.shared/LoaderBar/LoaderBar";
import PaymentData from "@brand/PaymentData/PaymentData";
import PropTypes from "prop-types";
import { PAYMENT_METHODS, USABLE_CREDITS_STATUS } from "app/constants";
import { isExternalPaymentError, isPaymentError } from "app/utils/paymentUtils";
import { paymentTypesValues } from "app/utils/propTypes";
import uniq from "lodash/uniq";
import { dependantPaymentCardFields } from "app/pages/Booking/Payment/paymentSchema";
import PaymentSecurityNote from "app/pages/Booking/Payment/PaymentSecurityNote";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { useEffect, useRef } from "react";
import useOnScreen from "app/pages/.shared/useOnScreen";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

function PaymentInfoSection({
	brandDisplayName,
	usableCouponsStatus,
	payment = {},
	shop,
	selectedPaymentType,
	paymentErrorList = [],
	fields = {},
	booking = {},
	error,
	paymentErrorMessageRef,
	paymentMethodsErrorMessageRef,
	handleInputBlur = () => {},
}) {
	const triggerChangeOnOtherDependantPaymentCardFields = touchedFieldName => {
		const cardPathName = booking.paymentType === PAYMENT_METHODS.BCMC ? "cardBCMC" : "card";

		dependantPaymentCardFields.forEach(fieldName => {
			if (fieldName !== touchedFieldName && fields.payment[cardPathName][fieldName].value) {
				fields.payment[cardPathName][fieldName].onChange(
					fields.payment[cardPathName][fieldName].value
				);
			}
		});
	};
	const handleCreditCardInformationChange = event => {
		const { fieldName: touchedFieldName } = event.target.dataset;
		const cardPathName = booking.paymentType === PAYMENT_METHODS.BCMC ? "cardBCMC" : "card";

		fields.payment[cardPathName][touchedFieldName].onChange(event);
		triggerChangeOnOtherDependantPaymentCardFields(touchedFieldName);
	};

	const isCouponsLoading =
		usableCouponsStatus === USABLE_CREDITS_STATUS.LOADING_CREDIT_NOTES ||
		usableCouponsStatus === USABLE_CREDITS_STATUS.LOADING_COUPONS;

	const { track } = useAnalytics();
	const ref = useRef();
	const isElementOnScreen = useOnScreen({ ref, triggerOnce: false });

	useEffect(() => {
		if (isElementOnScreen && !isCouponsLoading) {
			track("payment_view_Payment");
		}
	}, [isElementOnScreen, isCouponsLoading]);

	const bookStatus = payment.bookStatus;

	return (
		<>
			<Typography
				variant={TYPOGRAPHY_VARIANTS.XL3}
				variantMD={TYPOGRAPHY_VARIANTS.XL4}
				isBold
				className="payment__title"
				component="h2"
				innerRef={ref}
			>
				<FormattedMessage id="payment.payment.title" />
			</Typography>
			<PaymentSecurityNote brandDisplayName={brandDisplayName} />
			{isCouponsLoading ? (
				<div className="payment__content">
					<LoaderBar />
				</div>
			) : (
				<div className="payment__content">
					<PaymentData
						error={error}
						fields={fields}
						isExternalPaymentError={isExternalPaymentError(bookStatus)}
						isPaymentError={isPaymentError(bookStatus)}
						paymentErrorList={uniq(paymentErrorList)}
						onCreditCardInputsBlur={handleInputBlur}
						onCreditCardInformationChange={handleCreditCardInformationChange}
						selectedPaymentType={selectedPaymentType}
						shop={shop}
						paymentModesRef={paymentErrorMessageRef}
						paymentMethodsRef={paymentMethodsErrorMessageRef}
					/>
				</div>
			)}
		</>
	);
}
PaymentInfoSection.propTypes = {
	brandDisplayName: PropTypes.string,
	usableCouponsStatus: PropTypes.string,
	payment: PropTypes.object,
	shop: PropTypes.string,
	selectedPaymentType: paymentTypesValues,
	paymentErrorList: PropTypes.array,
	fields: PropTypes.object,
	error: PropTypes.object,
	paymentErrorMessageRef: PropTypes.string,
	paymentMethodsErrorMessageRef: PropTypes.string,
	handleInputBlur: PropTypes.func,
	booking: PropTypes.object,
};
export default PaymentInfoSection;
